export default __webpack_public_path__ + "static/media/onboardingWelcome.99cee495.png";